<template>
    <div
        v-if="showResponse"
        class="fixed bottom-8 w-1/5 rounded flex flex-col p-4"
        style="left:40%"
        :class="{ 'bg-error': data.status == 'error', 'bg-primary': data.status == 'success'}">
        <div>
            <span class="font-heading font-bold text-lg text-white">{{ data.head }}</span>
        </div>
        <div>
            <span class="font-heading font-light text-sm text-white">{{ data.body }}</span>
        </div>
    </div>
</template>

<script>
export default {
     components: {
    },

    props: {
        data: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            showResponse: true,
        }
    },

    computed: {
    },

    created() {
    },

    methods: {
    }
}
</script>
